'use client';

import * as React from 'react';
import styles from './styles.module.scss';
import ActiveLink from '@/components/ui/ActiveLink';
import { IHeaderProps } from '@/components/ui/Header';

export interface IMobileMenuLinksProps {
  links: IHeaderProps['links'];
}

const MobileMenuLinks: React.FunctionComponent<IMobileMenuLinksProps> = (props) => {
  if (props.links.length === 0) {
    return null;
  }

  return (
    <ul className={styles['mobile-menu-links']}>
      {props.links.map(({ label, ...link }, index) => (
        <li key={index}>
          <ActiveLink
            exact={true}
            {...link}
          >
            {label}
          </ActiveLink>
        </li>
      ))}
    </ul>
  );
};

MobileMenuLinks.displayName = 'MobileMenuLinks';

export default MobileMenuLinks;
